import { useParams } from "react-router-dom";
import "./JobWorkInfo.css";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import ReactToPrint from "react-to-print";
import { Button } from "@mui/material";

const FIxedEmpJbPrint = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const { Id } = useParams();
    const [formData, setFormData] = useState({});
    const [jobworkInfo, setJobworkInfo] = useState([]);
    const [jobObject, setJobObject] = useState({
        totdedamt: '0',
        totactamt: '0',
        totbalamt: '0'
    });
    const [attendanceInfo, setAttendanceInfo] = useState([]);
    const componentRef = useRef();

    useEffect(() => {
        fetchFixedEmpJobworkApi(Id);
    }, [Id]);

    const Paytypes = ["Advance", "Baki", "PF", "ESI", "PT", "Machinary", "Purchase"];

    const fetchFixedEmpJobworkApi = async (id) => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getFixedEmployeeJobworkReg&fixId=${id}`);
            const data = res?.data;
            // console.log(data);
            const totdedamt = data?.info?.reduce((acc, sum) => acc + parseFloat(sum.dedamt), 0);
            const totactamt = data?.info?.reduce((acc, sum) => acc + parseFloat(sum.actamt), 0);
            const totbalamt = data?.info?.reduce((acc, sum) => acc + parseFloat(sum.balamt), 0);
            setFormData(data?.data);

            const infodata = Paytypes?.map(item => {
                const value = data?.info?.find(val => val.paytype === item)
                    || { paytype: item, actamt: 0, dedamt: 0, balamt: 0 };;

                return value;
            });
            // console.log(infodata);

            setJobworkInfo(infodata);
            setJobObject(prev => ({
                ...prev,
                totactamt: Math.round(totactamt),
                totdedamt: Math.round(totdedamt),
                totbalamt: Math.round(totbalamt)
            }));
            setAttendanceInfo(data?.attendance_data);
        } catch (error) {
            console.error(error);
        }
    };

    const attendanceHeader = ["Date", "In1", "Out1", "In2", "Out2", "In3", "Out3", "In4", "Out4", "Working Hrs", "Schedule Type"];


    return (
        <>
            <div className="jw-wrapper" ref={componentRef}>
                <div className="jw-title-bar">Job Work Information</div>

                {/* Top Info */}
                <div className="jw-info-section">
                    <div className="jw-info-left">
                        <p><span>Entry Date</span> : {formData.entrydate}</p>
                        <p><span>From Date</span> : {formData.fromdt}</p>
                        <p><span>To Date</span> : {formData.todt}</p>
                        <p><span>Calculate By</span> : {formData.work_type}</p>
                        <p><span>Narration</span> : {formData.narr}</p>
                    </div>

                    <div className="jw-info-right">
                        <p><span>Ledger</span> : {formData.empNm}</p>
                        <p><span>Designation</span> : {formData.departName}</p>
                        <p><span>Work Hours</span> : {formData.work_hrs}</p>
                        <p><span>Per Hour Payment</span> : {formData.perHr_amt}</p>
                    </div>
                </div>

                {/* Work Table */}
                {/* <table className="jw-main-table">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Memo</th>
                        <th>Item Name</th>
                        <th>Quantity</th>
                        <th>Rate</th>
                        <th>Extra</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td colSpan="3" className="jw-align-right">Total</td>
                        <td>0</td>
                        <td></td>
                        <td></td>
                        <td>13005</td>
                    </tr>
                </tbody>
            </table> */}

                {/* Deduction Table */}
                <div className="jw-twosection-table">
                    <table className="jw-deduction-table">
                        <thead>
                            <tr>
                                <th></th>

                                {jobworkInfo?.map(item => (
                                    <th key={item.paytype}>{item.paytype}</th>
                                ))}
                                {/* <th>Advance</th>
                                <th>Baki</th>
                                <th>PF</th>
                                <th>ESI</th>
                                <th>PT</th>
                                <th>Machinary</th>
                                <th>Purchase</th> */}
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>Deduction</th>
                                {jobworkInfo?.map(item => (
                                    <td key={item.dedamt}>{item.dedamt}</td>
                                ))}
                                <td>{jobObject.totdedamt}</td>
                            </tr>
                            <tr>
                                <th>Balance</th>
                                {jobworkInfo?.map(item => (
                                    <td key={item.balamt}>{item.balamt}</td>
                                ))}
                                <td>{jobObject.totbalamt}</td>
                            </tr>
                        </tbody>
                    </table>

                    {/* Summary */}
                    <div className="jw-summary-box">
                        <p>Work Done : <strong>{Math.round(formData.amt)}</strong></p>
                        {/* <p>Work Done - MIL (new Software) : <strong>0</strong></p>
                        <p>Work Done - DU (new Software) : <strong>0</strong></p> */}
                        <p>Deduction (-) : <strong>{Math.round(formData.dedamt)}</strong></p>
                        <p className="jw-grand-total">Total Amount : <strong>{Math.round(formData.totamt)}</strong></p>
                    </div>
                </div>

                <div className="table-box">
                    <div className="table-title">Attendance Detail</div>
                    <table className="detail-table">
                        <thead>
                            {attendanceHeader?.map((item, index) => (
                                <th className="detail-th" key={index}>{item}</th>
                            ))}
                        </thead>
                        <tbody>
                            {attendanceInfo?.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.date}</td>
                                    <td>{item.in1}</td>
                                    <td>{item.out1}</td>
                                    <td>{item.in2}</td>
                                    <td>{item.out2}</td>
                                    <td>{item.in3}</td>
                                    <td>{item.out3}</td>
                                    <td>{item.in4}</td>
                                    <td>{item.out4}</td>
                                    <td>{item.tothrs}</td>
                                    <td>{item.schedule_type}</td>
                                </tr>
                            ))}
                            <tr>
                                <td colSpan={9}>Total</td>
                                <td>{formData.totworkingHrs}</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div style={{ margin: '2% 5%' }}>
                <ReactToPrint
                    trigger={() => <Button variant="contained" color="primary">Print</Button>}
                    content={() => componentRef.current}
                />
            </div>
        </>


    );
};

export default FIxedEmpJbPrint;
